<template>
  <transition name="fade">
    <div v-if="message" class="notification" :class="type">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  watch: {
    message(newValue) {
      if (newValue) {
        setTimeout(() => this.$emit('update:message', ''), this.duration);
      }
    }
  }
};
</script>


<style scoped>
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.notification {
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 999;
  transform: translate(-50%);
  max-width: 1000px;
  @apply .bg-grey-dark .px-8 .py-3 .rounded-b .text-white .text-sm .font-semibold;
}
.notification.success {
  @apply .bg-green-dark;
}
.notification.info {
  @apply .bg-blue-dark;
}
.notification.error {
  @apply .bg-red-dark;
}
</style>
